import React, { FC, useContext, useState } from "react";
import { Context } from "../index";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Button, Form, Input } from "antd";

const LoginForm: FC = () => {
  const [registration, setRegistration] = useState<boolean>(false);
  const { authStore } = useContext(Context);
  const { t } = useTranslation();

  const onFinish = (values: any) => {
    if (!registration) {
      authStore.login(values.email, values.password);
    } else {
      authStore.registration(values.email, values.password, values.username);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 24}}
      style={{ maxWidth: 600 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      {registration && <Form.Item
        label={t("username")}
        name="username"
        rules={[{ required: true, message: "Please input your username!" }]}
      >
        <Input />
      </Form.Item>}

      <Form.Item
        label={t("email")}
        name="email"
        rules={[{ required: true, message: "Please input your email!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("password")}
        name="password"
        rules={[{ required: true, message: "Please input your password!" }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="remember"
        valuePropName="checked"
        wrapperCol={{ span: 24 }}
      >
        {!registration
          ? t("If you don't have an account, please")
          : t("I already have an")}
        <Button
          type="link"
          size={"middle"}
          style={{ paddingLeft: '5px' }}
          onClick={() => setRegistration(!registration)}
        >
          {!registration ? t("register") : t("account")}
        </Button>
      </Form.Item>
      <Form.Item
        style={{ marginBottom: 0, float: 'right'}}
      >
        <Button type="primary" htmlType="submit">
          {!registration ? t("submit") : t("registration")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default observer(LoginForm);
